<template>
  <div>
    <!-- 修正：运算符前后添加空格，内联样式补充分号和空格 -->
    <div class="chat-robot-box text-message"
      v-if="message.source !== 'deepseekChat' && (message.content || message.question)">
      <em v-show="message.style" class="icon-dot" style="float: left; top: 0.05rem;"></em>
      <div class="text-message_content" :style="message.style && 'font-weight: bold;'"
        v-html="message.content || message.question"></div>
    </div>

    <!-- 修正：运算符空格、标签换行提升可读性 -->
    <div class="chat-robot-box text-message deepSeek" v-if="message.source === 'deepseekChat' && message.from === 1">
      <div class="header-deep"> <!-- 修正：拼写错误 heder-deep → header-deep -->
        <em class="icon-dot"></em>大模型回答内容
      </div>
      <div class="text-message_content" v-html="message.content"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BubbleTxt',
    // 修正：props 类型严谨化 + 添加默认值（ESLint要求：vue/require-default-prop）
    props: {
      types: {
        type: Number,
        default: 0 // 添加默认值
      },
      message: {
        type: Object, // 实际使用了message.source/from等属性，排除String类型
        default: () => ({ // 对象类型默认值必须是函数
          source: '',
          from: 0,
          content: '',
          question: '',
          style: false
        })
      }
    },
    watch: {
      types: {
        // 修正：函数参数换行+空格规范，添加注释（可选）
        handler (newVal, oldVal) {
          console.log('myObject changed:', newVal, oldVal) // 修正：语句结尾加分号
        },
        deep: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .deepSeek {
    background: #fff;
    border-radius: 20px;
    padding: 0;
    overflow: hidden;

    .text-message_content {
      padding: 10px;
      font-weight: 400 !important;
      line-height: 1.6;
    }

    .header-deep {
      background: #e8f0f8;
      font-size: 15px;
      padding-left: 10px;
      line-height: 40px;
      font-weight: bold;
    }
  }
</style>